import { fetchWrapper } from '@/_helpers';
import dayjs from 'dayjs';

export const checkEventConflicts = async (
    data,
    currUser,
    { setLoadingConflict, setConflictEndTime, setConflictEventTitle }
) => {
    try {
        setLoadingConflict(true);
        const start = new Date(data?.latestDatePointer || data?.date);
        const end = new Date(data?.latestDueDatePointer || data?.dueDate || new Date(start.valueOf() + 60 * 60 * 1000));

        if (isNaN(start) || isNaN(end) || end <= start) {
            setConflictEndTime(null);
            setConflictEventTitle(null);
            return;
        }

        const yyyyMM = dayjs(start).format('YYYY-MM');
        const monthTasksResponse = await fetchWrapper.get(
            `task?limit=200&page=1&month=${yyyyMM}&assignedUser=${currUser?._id || currUser?.id}&eventMode=live`
        );
        const internalRes = monthTasksResponse?.results || [];
        const external = monthTasksResponse?.externalEventList || [];
        const otherEvents = [
            ...internalRes.filter((t) => (t._id || t.id) !== (data?._id || data?.id)),
            ...(external || []),
        ];

        const getEventWindow = (event) => {
            const eventStart = new Date(event.start || event.latestDatePointer || event.date);
            const eventEnd = new Date(
                event.end ||
                    event.latestDueDatePointer ||
                    event.dueDate ||
                    new Date(eventStart.valueOf() + 60 * 60 * 1000)
            );
            return {
                start: eventStart,
                end: eventEnd,
                originalEvent: event,
            };
        };

        const hasOverlap = (window1, window2) => window1.start < window2.end && window2.start < window1.end;

        const currentWindow = { start, end };
        const conflictingEvents = [];

        otherEvents.forEach((event) => {
            const eventWindow = getEventWindow(event);

            if (hasOverlap(currentWindow, eventWindow)) {
                conflictingEvents.push({
                    event,
                    window: eventWindow,
                });
            }
        });

        if (conflictingEvents.length > 0) {
            const latestEnd = new Date(Math.max(...conflictingEvents.map((ce) => ce.window.end.valueOf())));
            const latestConflict = conflictingEvents.find((ce) => ce.window.end.valueOf() === latestEnd.valueOf());
            setConflictEndTime(latestEnd);
            setConflictEventTitle(latestConflict.event.title || latestConflict.event.name || '');
        } else {
            setConflictEndTime(null);
            setConflictEventTitle(null);
        }
    } catch (error) {
        setConflictEndTime(null);
        setConflictEventTitle(null);
    } finally {
        setLoadingConflict(false);
    }
};

export const buildEventUrl = (data) => {
    try {
        const taskId = data?._id || data?.id;
        const channelId =
            Array.isArray(data?.assignedChannel) && data?.assignedChannel.length ? data?.assignedChannel[0] : '';

        const base = window?.location?.origin || '';
        let url = `${base}/events${channelId ? `/${channelId}` : ''}`;

        if (taskId) {
            const params = new URLSearchParams();
            params.append('task', taskId);
            url += `?${params.toString()}`;
        }

        return url;
    } catch (e) {
        const base = window?.location?.origin || '';
        return `${base}/events`;
    }
};

export const getNameInitials = (name = '') =>
    name
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((n) => n[0]?.toUpperCase() || '')
        .join('');
